/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Button,
  Row,
  Col,
  Spin,
  Input,
  Modal,
  DatePicker,
} from 'antd';
import { formatReceived } from 'utils/formatValues';
import API from 'utils/api';
import { CheckCircleOutlined } from '@ant-design/icons';
import { onError, onSuccess } from 'utils/handlers';
import Table from 'components/Table';
import FormSubmitControls from 'components/FormSubmitControls';
import ModalDelete from 'components/ModalDelete';
import Select from 'components/Select';
import { getAreas, getEstadosGlobales } from 'api/catalogos/index';
import { integerRegExp } from 'utils/patterns';
import ModalConfirmation from 'components/ModalConfirmation';
import { getTiposDeEmpleados } from 'api/catalogos/tiposDeEmpleados';
import { checkToken } from 'api/utils';
import {
  ESTATUS_ACTIVO,
  ESTATUS_AUTORIZADO,
  ESTATUS_INACTIVO,
} from 'utils/constants';
import { getModelPermission } from 'utils/permission';
import { getPuestos } from 'api/estructuraOrganizacional/puestos';
import {
  autorizarConfiguracionExternaDescuentoDetalle,
  deleteConfiguracionExternaDescuentoDetalle,
  getConfiguracionExternaDescuentoDetalle, getConfiguracionExternaDescuentosDetalle, patchConfiguracionExternaDescuentoDetalle, postConfiguracionExternaDescuentoDetalle,
} from 'api/ConfiguracionCargaExternaDescuentosDetalle';
import { getConceptosCargaExterna } from 'api/catalogos/ConceptosCargaExterna';
import { getTodosDescuentos } from 'api/catalogos/TodosDescuentos';

export const ConfiguracionCargaExternaDescuentoDetallePermission = {
  permissionModel: 'descuentocargaexternadescuento',
  hasAllViewPermissions: true,
};

const ConfiguracionCargaExternaDescuentoDetalle = ({
  ConfiguracionCargaExternaDescuento, permission, showParentForm,
}) => {
  const [form] = Form.useForm();
  const [formDatos] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open2, setVisible2] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);
  const [, setConfirmationVisibleEstatus] = useState(false);
  const [estados, setEstados] = useState([]);
  const [tiposempleados, setTiposEmpleados] = useState([]);
  const [estatusInactivo, setEstatusInactivo] = useState(false);
  const [estatusAutorizado, setEstatusAutorizado] = useState(false);
  const [estadosFiltered, setEstadosFiltered] = useState([]);
  const [areas, setAreas] = useState([]);
  const [puesto, setPuesto] = useState([]);
  const [confirmationVisible, setConfirmationVisible] = useState(false);
  const [selectedData] = useState({});
  const [pageActual, setPageActual] = useState(1);
  const [descuentos, setDescuentos] = useState([]);

  const formInstances = [
    form,
    formDatos,
  ];

  const fetchData = async () => {
    setLoading(true);
    const _data = await getConfiguracionExternaDescuentosDetalle({ descuento_carga_externa: ConfiguracionCargaExternaDescuento?.id });
    setData(formatReceived(_data));
    setLoading(false);
  };

  const fetchPaginated = async (page = 1) => {
    const baseURI = 'nominas/descuentos-carga-externa-descuento';
    try {
      setLoading(true);

      const cleanPage = Number(String(page).replace(/\D/g, '')); // solo dígitos
      const response = await API.get(baseURI, { params: { page: cleanPage } });

      const { results } = response.data;

      setSelectedRowKeys([]);
      setPageActual(cleanPage);
      setData({ ...response.data, results });
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };
  const fetchConceptos = async () => {
    if (!descuentos.length) {
      const descuento = await getTodosDescuentos();
      const descuentosFormateados = descuento.map((item) => ({
        ...item,
        descripcion: `${item.clave} - ${item.concepto}`,
      }));
      setDescuentos(descuentosFormateados);

      const _estados = await getEstadosGlobales();
      setEstados(_estados);
    }
  };
  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [_estados, _data] = await Promise.all([
        getEstadosGlobales(),
        getConfiguracionExternaDescuentosDetalle({ descuento_carga_externa: ConfiguracionCargaExternaDescuento?.id }),
      ]);
      const { results } = _data;
      if (mounted) {
        setEstados(_estados);
        setData({ ..._data, results });
        setLoading(false);
      }
    };

    if (ConfiguracionCargaExternaDescuento?.id) {
      fetchAll();
    }

    return () => { mounted = false; };
  }, [ConfiguracionCargaExternaDescuento]);

  const onCancel = () => {
    setEstatusInactivo(false);
    setEstatusAutorizado(false);
    setSelectedRowKeys([]);
    setVisible2(false);
    showParentForm();
    form.resetFields();
    formDatos.resetFields();
  };

  const onClickEdit = async (responseData = null) => {
    setLoading(true);
    const [key] = selectedRowKeys;

    // Usa el parámetro recibido o busca por la selección
    const match = responseData || data?.results?.find((item) => item.id === key);
    if (!match) {
      setLoading(false);
      return;
    }

    await fetchConceptos();

    try {
      const detalle = await getConfiguracionExternaDescuentoDetalle(match.id); // definida en  archivo api
      if (detalle) {
        const parsed = formatReceived(detalle);
        form.resetFields();
        formDatos.resetFields();
        form.setFieldsValue(parsed);
        formDatos.setFieldsValue(parsed);
        setVisible2(true);
      }
    } catch (err) {
    // ya manejado internamente por onError, así que opcionalmente se  puede dejarlo vacío
    } finally {
      setLoading(false);
    }
  };

  const onFinish = async (_values, _continue = false) => {
    try {
      setLoading(true);
      await form.validateFields();
      await formDatos.validateFields();

      const [key] = selectedRowKeys;

      const formValues = {
        ...form.getFieldsValue(),
        ...formDatos.getFieldsValue(),
      };

      const values = {
        ...formValues,
        descuento_carga_externa: ConfiguracionCargaExternaDescuento?.id,
        concepto_carga_externa: ConfiguracionCargaExternaDescuento?.concepto_carga_externa_id,
      };

      const saved = await (
        key
          ? patchConfiguracionExternaDescuentoDetalle(key, values)
          : postConfiguracionExternaDescuentoDetalle(values)
      );

      if (saved) {
        if (_continue) {
          await fetchData();
          setSelectedRowKeys([saved.id]);
          onClickEdit(saved);
        } else {
          onCancel();
          await fetchData();
        }
      }

      setLoading(false);
    } catch (err) {
      onError(err, setLoading, formInstances);
    }
  };

  const deleteItem = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        const [key] = selectedRowKeys;
        const deleted = await deleteConfiguracionExternaDescuentoDetalle(key);
        if (deleted) {
          setVisibleAlert(false);
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    form.setFieldsValue(record);
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const onClickAdd = async () => {
    await fetchConceptos();
    form.resetFields();
    formDatos.resetFields();
    setSelectedRowKeys([]);
    setVisible2(true);
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };
  const onConfirmAutorizar = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        onSuccess({}, 'No se puede autorizar La  ya autorizada');
        return;
      }
      const saved = await autorizarConfiguracionExternaDescuentoDetalle(key);
      if (saved) {
        const _data = await getConfiguracionExternaDescuentosDetalle({ descuento_carga_externa: ConfiguracionCargaExternaDescuento?.id });
        setData(formatReceived(_data));
        onCancel();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const columns = [
    {
      titleText: 'Descuento',
      dataIndex: 'descuento_clave_y_concepto',
      key: 'descuento_clave_y_concepto',
      width: 100,
    },

    {
      titleText: 'Concepto Relacionado',
      dataIndex: 'concepto_relacionado',
      key: 'concepto_relacionado',

      width: 300,
    },
    {
      titleText: 'Fecha final',
      dataIndex: 'fecha_final',
      key: 'fecha_final',
      width: 400,
    },
    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales_descripcion',
      key: 'estados_globales_descripcion',
      width: 200,
    },
  ];

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
    concepto: [requiredRule],
    horas: [
      requiredRule,
      {
        pattern: integerRegExp,
        validator: async () => {
          const { horas_en_jornada } = form.getFieldsValue();
          // eslint-disable-next-line no-restricted-globals
          if (isNaN(horas_en_jornada)) {
            throw new Error('Ingrese un valor válido');
          }
          if (horas_en_jornada > 24) {
            throw new Error('No se puede exceder el número de horas de un día');
          }
        },
      },
    ],
  };

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Table
          cols={columns}
          data={data?.results || []}
          rowSelection={rowSelection}
          pagination={false}
          paginationCallback={fetchPaginated}
          count={data?.count || 0}
          handleOnRowClick={handleOnRowClick}
          controls={{
            onClickAdd,
            onClickEdit: () => onClickEdit(),
            onClickDelete,
          }}
          customActions={[
            {
              onClick: () => setConfirmationVisible(true),
              permission: { model: 'descuentocargaexternadescuento', action: 'autorizar' },
              text: 'Autorizar',
              icon: <CheckCircleOutlined />,
              disabledBySelection: false,
              className: 'success',
            },
          ]}
          disableDelete={selectedData?.estados_globales === ESTATUS_AUTORIZADO}
          permission={permission}
          allowExportPDF={false}
        />

        {/* El modal siempre está presente, pero se muestra solo si open2 es true */}
        <Modal
          open={open2}
          closable={false}
          maskClosable={!loading}
          keyboard={!loading}
          footer={null}
          title={(
            <FormSubmitControls
              label={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} CONFIGURACIÓN DE CARGA EXTERNA DE DESCUENTOS`}
              onFinish={onFinish}
              onCancel={onCancel}
              loading={loading}
            />
                      )}
          onCancel={onCancel}
          forceRender
        >
          <Form
            layout="vertical"
            form={form}
            name="general"
            onFinish={() => onFinish()}
            scrollToFirstError
          >
            <Col xs={24} sm={24} md={24}>
              <Form.Item
                label="Concepto"
              >
                <Input
                  value={ConfiguracionCargaExternaDescuento?.concepto_carga_externa_nombre}
                  readOnly
                  disabled
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={24}>
              <Form.Item
                name="descuento"
                label="Descuento"
              >
                <Select
                  labelProp="descripcion"
                  keyProp="id"
                  dataSource={descuentos}
                  allowClear
                  placeholder="Seleccione un concepto (opcional)"
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={24}>
              <Form.Item
                name="concepto_relacionado"
                label="Concepto Relacionado"
                rules={[{ required: true, message: 'Campo requerido' }]}
              >
                <Input disabled={estatusAutorizado || estatusInactivo} />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={24}>
              <Form.Item name="fecha_final" label="Fecha Final">
                <DatePicker style={{ width: '100%' }} disabled={estatusAutorizado || estatusInactivo} />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={24}>
              <Form.Item
                name="estados_globales"
                label="Estatus"
                rules={rules.estatus}
                hasFeedback
                initialValue={1}
              >
                <Select
                  labelProp="descripcion"
                  keyProp="id"
                  dataSource={estados}
                  disabled
                />
              </Form.Item>
            </Col>

            <Form.Item hidden>
              <Button htmlType="submit" />
            </Form.Item>

          </Form>

        </Modal>

        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          open={visibleAlert}
          content={`Descuento: ${form.getFieldValue('descuento_clave_y_concepto') || ''}\nConcepto Relacionado: ${form.getFieldValue('concepto_relacionado') || ''}`}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={onConfirmAutorizar}
          ConfirmAutorize
          onCancel={() => {
            setConfirmationVisible(false);
          }}
          open={confirmationVisible}
          contentTitle={`autorizar el descuento "${form.getFieldValue('descuento_clave_y_concepto') || ''}" con concepto relacionado "${form.getFieldValue('concepto_relacionado') || ''}"?`}
          loading={loading}
        />
      </Spin>
    </Row>
  );
};

export default ConfiguracionCargaExternaDescuentoDetalle;
